
export enum EmployeeStatus {
    None = 0,
    Active = 1,
    Inactive = 2,
    Locked = 3
}
